import { render, staticRenderFns } from "./schools.page.vue?vue&type=template&id=3a0d5daa&scoped=true&"
import script from "./schools.page.vue?vue&type=script&lang=js&"
export * from "./schools.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d5daa",
  null
  
)

export default component.exports